import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'parent-interview-official-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './parent-interview-official-signature.component.html',
  styleUrl: './parent-interview-official-signature.component.css'
})
export class ParentInterviewOfficialSignatureComponent implements OnInit, OnChanges {
  
  @Input() parentInterviewData: any;
  @Output() onSaveSection12 = new EventEmitter<any>();

  currentDate = new Date();
  parentSignatureForm: FormGroup = new FormGroup([]);

  constructor(  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.parentSignatureForm = new FormGroup({
      user_signature_name: new FormControl('', Validators.required),
    });
  }

  saveParentSignature(): void {
    if (this.parentSignatureForm.valid) {
        this.onSaveSection12.emit(this.parentSignatureForm.value);
    }
  }



}
